import { render, staticRenderFns } from "./TrendStatistics.vue?vue&type=template&id=0fa938a0&scoped=true"
import script from "./TrendStatistics.vue?vue&type=script&lang=js"
export * from "./TrendStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa938a0",
  null
  
)

export default component.exports